(() => {
  'use strict';
  const currencyFormatter = (root) => {
    let locale = root.dataset.nebV12Locale || document.documentElement.lang || 'en-US';
    let currency = root.dataset.nebV12Currency || window.Shopify?.currency?.active || 'USD';
    try { return new Intl.NumberFormat(locale, { style: 'currency', currency }); }
    catch (_) { return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }); }
  };
  const getQty = (root) => {
    const field = root.querySelector('.ct-quantity input[name="quantity"]');
    if (!field) return 1;
    const min = Math.max(1, Number(field.min) || 1);
    const max = Number(field.max) > 0 ? Number(field.max) : Infinity;
    const raw = Math.trunc(Number(field.value));
    return Math.min(max, Math.max(min, Number.isFinite(raw) ? raw : min));
  };
  const bundleStrings = JSON.parse(document.getElementById('neb-bundle-strings')?.textContent || '{}');
  const interpolate = (text, values) => Object.entries(values).reduce((str, [key,value]) => str.replaceAll(`__${key.toUpperCase()}__`,String(value)), text || '');
  let cartCount = null;
  const paintBundle = (root, quantity) => {
    const widget = root.querySelector('[data-neb-bundle]');
    if (!widget) return;
    const existing = cartCount ?? Math.max(0, Number(widget.dataset.cartCount) || 0);
    const previewQuantity = quantity + existing;
    const enabled = widget.dataset.enabled === 'true';
    const tiers = [...widget.querySelectorAll('[data-neb-tier]')].sort((a,b) => Number(a.dataset.nebTier)-Number(b.dataset.nebTier));
    const active = tiers.filter(tier => previewQuantity >= Number(tier.dataset.nebTier)).at(-1);
    const percent = enabled ? Math.min(100,Math.max(0,Number(active?.dataset.discount) || 0)) : 0;
    const next = tiers.find(tier => Number(tier.dataset.nebTier) > previewQuantity);
    const targetQuantity = Math.max(1,...tiers.map(tier => Number(tier.dataset.nebTier) || 0));
    tiers.forEach(tier => tier.classList.toggle('is-active', enabled && tier === active));
    const meter = widget.querySelector('[data-neb-bundle-meter]');
    if (meter) {
      meter.hidden = !enabled;
      meter.style.setProperty('--neb-bundle-progress',`${Math.min(100,previewQuantity/targetQuantity*100)}%`);
      meter.querySelectorAll('[data-neb-bundle-step]').forEach(step => step.classList.toggle('is-reached',previewQuantity >= Number(step.dataset.nebBundleStep)));
      const progress = meter.querySelector('[data-neb-bundle-progress]');
      progress.max = targetQuantity;
      progress.value = Math.min(targetQuantity,previewQuantity);
      progress.setAttribute('aria-valuetext',interpolate(bundleStrings.progress,{count:previewQuantity}));
    }
    const message = widget.querySelector('[data-neb-bundle-message]');
    const saving = widget.querySelector('[data-neb-bundle-savings]');
    const priceCents = Number(root.dataset.nebV12UnitPrice);
    if (saving) {
      saving.hidden = !enabled || !percent || !Number.isFinite(priceCents) || priceCents < 0;
      const savingsCents = Math.round(Math.max(0,priceCents || 0)*quantity*percent/100);
      saving.textContent = interpolate(bundleStrings.savings,{percent,amount:currencyFormatter(root).format(savingsCents/100)});
      saving.dataset.savingCents = String(savingsCents);
    }
    if (message) message.textContent = !enabled ? bundleStrings.inactive : next ? interpolate(bundleStrings.next,{count:Number(next.dataset.nebTier)-previewQuantity,percent:next.dataset.discount}) : bundleStrings.top;
    const context = widget.querySelector('[data-neb-bundle-cart-note]');
    if (context) { context.hidden = existing === 0; context.textContent = interpolate(bundleStrings.cart,{count:existing}); }
  };
  let offerTimer;
  const cycleEpoch = (duration) => {
    const key = `neb-offer-cycle-v14-${duration}`;
    let epoch = Date.now();
    try {
      const stored = Number(localStorage.getItem(key));
      if (stored > 0 && stored <= epoch) return stored;
      localStorage.setItem(key,String(epoch));
    } catch (_) {}
    if (!window.nebOfferEpochs) window.nebOfferEpochs = {};
    return window.nebOfferEpochs[key] ||= epoch;
  };
  const paintCycles = () => {
    document.querySelectorAll('[data-neb-offer-cycle]').forEach(cycle => {
      const duration = (Math.max(1,Number(cycle.dataset.days)||5) * 24 + Math.max(0,Number(cycle.dataset.hours)||0)) * 3600000;
      if (!cycle.dataset.epoch) cycle.dataset.epoch = cycleEpoch(duration);
      const elapsed = Math.max(0,Date.now()-Number(cycle.dataset.epoch));
      const remaining = Math.ceil((duration - elapsed % duration) / 1000);
      const d = Math.floor(remaining/86400);
      const h = Math.floor(remaining%86400/3600);
      const m = Math.floor(remaining%3600/60);
      const sec = remaining%60;
      const target = cycle.querySelector('[data-neb-offer-time]');
      if (target) { target.textContent = `${d}d ${String(h).padStart(2,'0')}:${String(m).padStart(2,'0')}:${String(sec).padStart(2,'0')}`; target.dateTime = `P${d}DT${h}H${m}M${sec}S`; }
    });
  };
  const addBusinessDays = (base, totalDays) => {
    const copy = new Date(base.getFullYear(), base.getMonth(), base.getDate(), 12, 0, 0);
    let remaining = Math.max(0, Math.floor(Number(totalDays) || 0));
    while (remaining > 0) {
      copy.setDate(copy.getDate() + 1);
      if (copy.getDay() !== 0 && copy.getDay() !== 6) remaining -= 1;
    }
    return copy;
  };
  const paintDelivery = (root) => {
    const widget = root.querySelector('[data-neb-v12-delivery]');
    if (!widget || widget.dataset.nebV12Ready === 'true') return;
    widget.dataset.nebV12Ready = 'true';
    const initial = new Date();
    const procMin = Number(widget.dataset.processingMin || 0);
    const procMax = Number(widget.dataset.processingMax || 0);
    const transitMin = Number(widget.dataset.transitMin || 0);
    const transitMax = Number(widget.dataset.transitMax || 0);
    const placed = widget.querySelector('[data-neb-v12-placed]');
    const ships = widget.querySelector('[data-neb-v12-ships]');
    const delivered = widget.querySelector('[data-neb-v12-arrives]');
    const note = widget.querySelector('[data-neb-v12-delivery-note]');
    const locale = root.dataset.nebV12Locale || document.documentElement.lang || 'en-US';
    const fmt = new Intl.DateTimeFormat(locale, { month: 'short', day: 'numeric' });
    const range = (a, b) => a.getTime() === b.getTime() ? fmt.format(a) : `${fmt.format(a)} – ${fmt.format(b)}`;
    if (placed) placed.textContent = fmt.format(initial);
    if (procMin > 0 && procMax > 0) {
      const earliestShip = addBusinessDays(initial, Math.min(procMin, procMax));
      const latestShip = addBusinessDays(initial, Math.max(procMin, procMax));
      if (ships) ships.textContent = range(earliestShip, latestShip);
      if (transitMin > 0 && transitMax > 0) {
        const earliestDelivery = addBusinessDays(earliestShip, Math.min(transitMin, transitMax));
        const latestDelivery = addBusinessDays(latestShip, Math.max(transitMin, transitMax));
        if (delivered) delivered.textContent = range(earliestDelivery, latestDelivery);
        if (note) note.textContent = `Standard shipping (free): ${procMin} production + ${transitMin}–${transitMax} transit business days, or ${procMin + transitMin}–${procMax + transitMax} business days in total. For eligible Main-zone destinations. Estimates exclude weekends, holidays, and carrier/customs delays.`;
      } else if (note) {
        note.textContent = 'Production dates use business days (Mon–Fri). Transit estimates depend on destination, customs and carrier schedules.';
      }
    }
  };
  const update = (root) => {
    if (!root) return;
    const qty = getQty(root);
    const targets = root.querySelectorAll('[data-neb-v12-atc-total]');
    const priceCents = Number(root.dataset.nebV12UnitPrice);
    if (Number.isFinite(priceCents) && priceCents >= 0) {
      targets.forEach(target => { target.textContent = currencyFormatter(root).format(priceCents * qty / 100); });
    }
    paintBundle(root, qty);
    paintDelivery(root);
    paintCycles();
  };
  const updateAll = () => { document.querySelectorAll('[data-ct-product]').forEach(update); if (!offerTimer) offerTimer = setInterval(() => { if (!document.hidden) paintCycles(); },1000); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateAll, { once: true });
  else updateAll();
  document.addEventListener('input', event => {
    if (event.target.matches('[data-ct-product] .ct-quantity input[name="quantity"]')) update(event.target.closest('[data-ct-product]'));
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-ct-product] .ct-quantity input[name="quantity"]')) update(event.target.closest('[data-ct-product]'));
  });
  document.addEventListener('neb:cart-count-changed', event => { cartCount = Math.max(0,Number(event.detail?.count) || 0);updateAll(); });
  document.addEventListener('ct:variant-changed', () => updateAll());
  document.addEventListener('shopify:section:load', () => updateAll());
})();
